import { proctoringThunk } from '../store/exam/thunks';
import { setNotification } from '../store/general/slice';
import { useDispatch } from '../store/store';
import { useEffect, useRef } from 'react';

export const useProctoring = (
    userId: string | null,
    examId: string | undefined,
    questionNumber: number,
    type: 'multipleChoiceExam' | 'codingExam',
    isPaused?: boolean,
) => {
    const dispatch = useDispatch();
    const isBlurred = useRef(false);

    useEffect(() => {
        const handleFocus = () => {
            if (isBlurred.current && !isPaused) {
                dispatch(proctoringThunk({
                    type,
                    userId,
                    examId,
                    actionId: 2,
                    question: questionNumber,
                }));
                isBlurred.current = false; // Reset blur state
                dispatch(setNotification(['Warning, you must stay in the exam tab until the end.', 'error']));
            }
        };

        const handleBlur = () => {
            if (!isBlurred.current && !isPaused) {
                dispatch(proctoringThunk({
                    type,
                    userId,
                    examId,
                    actionId: 1,
                    question: questionNumber,
                }));
                isBlurred.current = true; // Set blur state
            }
        };

        const handleVisibilityChange = () => {
            if (document.visibilityState === 'hidden') {
                handleBlur();
            } else if (document.visibilityState === 'visible') {
                handleFocus();
            }
        };

        window.addEventListener('focus', handleFocus);
        window.addEventListener('blur', handleBlur);
        document.addEventListener('visibilitychange', handleVisibilityChange);

        // Cleanup event listeners on unmount
        return () => {
            window.removeEventListener('focus', handleFocus);
            window.removeEventListener('blur', handleBlur);
            document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, [questionNumber]);
};